import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Trophy, Bell, User, Menu, X } from 'lucide-react';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  return (
    <motion.header
      initial={{ y: -100 }}
      animate={{ y: 0 }}
      className="glass-card mb-8 p-6"
    >
      <div className="flex items-center justify-between">
        <motion.div
          whileHover={{ scale: 1.05 }}
          className="flex items-center space-x-3"
        >
          <div className="relative">
            <Trophy className="w-8 h-8 text-yellow-400" />
            <motion.div
              animate={{ scale: [1, 1.2, 1] }}
              transition={{ duration: 2, repeat: Infinity }}
              className="absolute -top-1 -right-1 w-3 h-3 bg-green-400 rounded-full"
            />
          </div>
          <div>
            <h1 className="text-2xl md:text-3xl font-bold bg-gradient-to-r from-football-green-400 to-yellow-400 bg-clip-text text-transparent">
              Football Schedule
            </h1>
            <p className="text-white/60 text-sm">Jadwal Pertandingan Terlengkap</p>
          </div>
        </motion.div>

        {/* Desktop Menu */}
        <nav className="hidden md:flex items-center space-x-6">
          <motion.a
            whileHover={{ scale: 1.1 }}
            href="#"
            className="text-white/80 hover:text-white transition-colors"
          >
            Beranda
          </motion.a>
          <motion.a
            whileHover={{ scale: 1.1 }}
            href="#"
            className="text-white/80 hover:text-white transition-colors"
          >
            Pertandingan
          </motion.a>
          <motion.a
            whileHover={{ scale: 1.1 }}
            href="#"
            className="text-white/80 hover:text-white transition-colors"
          >
            Klasemen
          </motion.a>
          <motion.button
            whileHover={{ scale: 1.1 }}
            whileTap={{ scale: 0.9 }}
            className="relative"
          >
            <Bell className="w-6 h-6 text-white/80 hover:text-white" />
            <span className="absolute -top-1 -right-1 w-4 h-4 bg-red-500 rounded-full text-xs flex items-center justify-center">
              3
            </span>
          </motion.button>
          <motion.button
            whileHover={{ scale: 1.1 }}
            whileTap={{ scale: 0.9 }}
            className="w-10 h-10 rounded-full bg-gradient-to-r from-football-green-500 to-football-green-600 flex items-center justify-center"
          >
            <User className="w-5 h-5 text-white" />
          </motion.button>
        </nav>

        {/* Mobile Menu Button */}
        <motion.button
          whileTap={{ scale: 0.9 }}
          className="md:hidden"
          onClick={() => setIsMenuOpen(!isMenuOpen)}
        >
          {isMenuOpen ? (
            <X className="w-6 h-6 text-white" />
          ) : (
            <Menu className="w-6 h-6 text-white" />
          )}
        </motion.button>
      </div>

      {/* Mobile Menu */}
      <motion.div
        initial={false}
        animate={{ height: isMenuOpen ? 'auto' : 0, opacity: isMenuOpen ? 1 : 0 }}
        className="md:hidden overflow-hidden"
      >
        <div className="pt-4 space-y-4">
          <a href="#" className="block text-white/80 hover:text-white py-2">Beranda</a>
          <a href="#" className="block text-white/80 hover:text-white py-2">Pertandingan</a>
          <a href="#" className="block text-white/80 hover:text-white py-2">Klasemen</a>
          <div className="flex items-center space-x-4 pt-2">
            <button className="relative">
              <Bell className="w-6 h-6 text-white/80" />
              <span className="absolute -top-1 -right-1 w-4 h-4 bg-red-500 rounded-full text-xs flex items-center justify-center">
                3
              </span>
            </button>
            <button className="w-10 h-10 rounded-full bg-gradient-to-r from-football-green-500 to-football-green-600 flex items-center justify-center">
              <User className="w-5 h-5 text-white" />
            </button>
          </div>
        </div>
      </motion.div>
    </motion.header>
  );
};

export default Header;
